const GOOGLE_CLIENT_ID = '542349111977-nim79s3caqfskm09inpv87uonksujnia.apps.googleusercontent.com';

export default GOOGLE_CLIENT_ID;
